import { avatarProgression, type AvatarReward, type Selection } from '../../lib/avatar';
import { avatarWords } from '../../lib/strings/avatar-rewards';
import { useLocale, useStrings } from '../../state/useLocale';
import { OperatorPlate } from './Operator';

/** Rewards are derived from the catalogue, never a second unlock schedule. */
export function AvatarRewards({ level, selection, onPick, busy = false }: {
  level: number;
  selection: Selection;
  onPick?(reward: AvatarReward): void;
  busy?: boolean;
}) {
  const { locale } = useLocale();
  const s = avatarWords[locale];
  const names = useStrings().profile.parts;
  const journey = avatarProgression(level);
  const shelf = (rewards: AvatarReward[], earned: boolean) => (
    <div className="avatar-reward-list">
      {rewards.map((reward) => {
        const name = names[reward.rail]?.[reward.key] ?? reward.label;
        const figure = <OperatorPlate seed={{ ...selection, [reward.rail]: reward.index }} size={32} motion={false} className="part-plate" />;
        const copy = <><strong>{name}</strong><span className="note">{earned ? s.unlocked : s.preview}</span></>;
        return onPick ? (
          <button type="button" className="avatar-reward" key={`${reward.rail}-${reward.key}`} disabled={busy} onClick={() => onPick(reward)}>
            {figure}<span className="avatar-reward-copy">{copy}</span>
          </button>
        ) : (
          <div className="avatar-reward" key={`${reward.rail}-${reward.key}`}>
            {figure}<span className="avatar-reward-copy"><strong>{name}</strong><span className="note">{earned ? s.unlocked : s.remaining(journey.remaining)}</span></span>
          </div>
        );
      })}
    </div>
  );
  return (
    <div className="avatar-journey">
      <div className="avatar-journey-head"><h3>{s.title}</h3><span className="label">{s.progress(journey.cleared)}</span></div>
      <p className="note">{s.why}</p>
      {journey.latest.length > 0 && <div><p className="label">{s.latest}</p>{shelf(journey.latest, true)}</div>}
      {journey.nextLevel !== null ? (
        <div>
          <div className="avatar-journey-head"><p className="label">{s.next}</p><span className="note">{s.remaining(journey.remaining)}</span></div>
          <progress className="avatar-journey-meter" value={journey.fraction} max={1} aria-label={s.remaining(journey.remaining)} />
          {shelf(journey.next, false)}
        </div>
      ) : <p className="note">{s.complete}</p>}
    </div>
  );
}
